<template>
  <div class="drivers">
    <loading :active.sync="isLoading"
             :can-cancel="true">
    </loading>

    <div class="col-12 text-left">
      <h1>{{ title }}</h1>
      <h6 class="text-danger" v-if="non_field_errors">{{ non_field_errors }}</h6>
    </div>

    <div class="row">
      <div class="col-md-2 col-lg-2 m-0 p-0">
        <label class="search-label">User ID</label>
        <input type="text" placeholder="User ID" v-model="id_driver"
               class="form-control"/>
        <div v-if="errors" class="text-danger">{{ errors.id_driver }}</div>
      </div>

      <!--<div class="col-md-10 col-lg-10 m-0 p-0"></div>-->

      <div class="col-md-2 col-lg-2 m-0 p-0">
        <label class="search-label">Social Security Number</label>
        <input type="text" placeholder="SSN" v-model="ssn"
               class="form-control"/>
        <div v-if="errors" class="text-danger">{{ errors.ssn }}</div>
      </div>
      <div class="col-md-2 col-lg-2 m-0 p-0">
        <label class="search-label">Driver License Number</label>
        <input type="text" placeholder="DL Number" v-model="driver_license_number"
               class="form-control"/>
        <div v-if="errors" class="text-danger">{{ errors.driver_license_number }}</div>
      </div>
      <div class="col-md-2 col-lg-2 m-0 p-0">
        <label class="search-label">Driver License State</label>
        <input type="text" placeholder="DL State" v-model="driver_license_state"
               class="form-control"/>
        <div v-if="errors" class="text-danger">{{ errors.driver_license_state }}</div>
      </div>

      <!--<div class="col-md-6 col-lg-6 m-0 p-0"></div>-->

      <div class="col-md-2 col-lg-3 m-0 p-0">
        <label class="search-label">Driver License Expiration Date</label>
        <VueCtkDateTimePicker v-model="driver_license_expires_at" format="YYYY-MM-DD HH:mm:ss" label="Driver License Expiration" />
        <div v-if="errors" class="text-danger">{{ errors.driver_license_expires_at }}</div>
      </div>
    </div>

    <div class="submit-button">
      <button v-on:click="buttonCreate()" class="btn btn-primary btn-sm" style="width:100%">Create</button>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'

  // Import component
  import Loading from 'vue-loading-overlay'
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'

  export default {
    name: 'CreateDriver',
    data () {
      return {
        title: 'Create a driver',
        isLoading: false,
        errors: null,
        non_field_errors: null,
        id_driver: 1,
        ssn: '111-222-3333',
        driver_license_number: 'NH87JU',
        driver_license_state: 'CA',
        driver_license_expires_at: null
      }
    },
    components: {
      Loading
    },
    methods: {
      buttonCreate: function () {
        this.reset()
        this.isLoading = true
        this.$http
          .post(process.env.API_BASE_URL_CS + 'drivers/', {
            id_driver: this.id_driver,
            ssn: this.ssn,
            driver_license_number: this.driver_license_number,
            default_dropoff_address: this.default_dropoff_address,
            driver_license_state: this.driver_license_state,
            driver_license_expires_at: this.driver_license_expires_at
          })
          .then(response => {
            Vue.toasted.show('Success!', {
              theme: 'bubble',
              position: 'top-right',
              duration: 2000
            })
            console.log(response.data)
            this.id_ride = response.data.id_ride
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            Vue.toasted.show('Something went wrong!', {
              theme: 'bubble',
              position: 'top-right',
              duration: 2000
            })
            console.log(error.response)
            this.errors = error.response.data
            this.non_field_errors = error.response.data.non_field_errors
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      reset: function () {
        this.errors = null
        this.non_field_errors = null
        this.id_ride = null
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .submit-button {
    /*position: fixed;*/
    /*bottom: 60px;*/
    /*right: 50%;*/
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/CreateDriver.vue